import { gql } from '@apollo/client';

export const REVOKE_SMS_MARKETING_CONSENT = gql`
  mutation RevokeMarketingConsent(
    $submissionId: String!
    $formId: Int!
    $consentType: String!
    $testMode: Boolean
  ) {
    revokeMarketingConsent(
      submissionId: $submissionId
      formId: $formId
      consentType: $consentType
      testMode: $testMode
    ) {
      result
      message
      data
    }
  }
`;

export const GRANT_SMS_MARKETING_CONSENT = gql`
  mutation GrantMarketingConsent(
    $submissionId: String!
    $formId: Int!
    $consentType: String!
    $testMode: Boolean
  ) {
    grantMarketingConsent(
      submissionId: $submissionId
      formId: $formId
      consentType: $consentType
      testMode: $testMode
    ) {
      result
      message
      data
    }
  }
`;

export const GRANT_EMAIL_MARKETING_CONSENT = gql`
  mutation GrantMarketingConsent(
    $submissionId: String!
    $formId: Int!
    $consentType: String!
    $testMode: Boolean
  ) {
    grantMarketingConsent(
      submissionId: $submissionId
      formId: $formId
      consentType: $consentType
      testMode: $testMode
    ) {
      result
      message
      data
    }
  }
`;

export const REVOKE_EMAIL_MARKETING_CONSENT = gql`
  mutation RevokeMarketingConsent(
    $submissionId: String!
    $formId: Int!
    $consentType: String!
    $testMode: Boolean
  ) {
    revokeMarketingConsent(
      submissionId: $submissionId
      formId: $formId
      consentType: $consentType
      testMode: $testMode
    ) {
      result
      message
      data
    }
  }
`;

export const GRANT_OTT_MARKETING_CONSENT = gql`
  mutation GrantMarketingConsent(
    $submissionId: String!
    $formId: Int!
    $consentType: String!
    $testMode: Boolean
  ) {
    grantMarketingConsent(
      submissionId: $submissionId
      formId: $formId
      consentType: $consentType
      testMode: $testMode
    ) {
      result
      message
      data
    }
  }
`;

export const REVOKE_OTT_MARKETING_CONSENT = gql`
  mutation RevokeMarketingConsent(
    $submissionId: String!
    $formId: Int!
    $consentType: String!
    $testMode: Boolean
  ) {
    revokeMarketingConsent(
      submissionId: $submissionId
      formId: $formId
      consentType: $consentType
      testMode: $testMode
    ) {
      result
      message
      data
    }
  }
`;

export const areConsentOptionsRequired = ({
  isSmsMarketingConsentRequired,
  isEmailMarketingConsentRequired,
  isOttMarketingConsentRequired,
  consentedSuppliersHash,
}) =>
  (isEmailMarketingConsentRequired ||
    isSmsMarketingConsentRequired ||
    isOttMarketingConsentRequired) &&
  Boolean(consentedSuppliersHash);
